<template>
  <div class="stepper-container">
    <div class="stepper-overlay" :class="{'is-active': overlay}"></div>
    <div class="container">
      <v-stepper v-model="activeStep" alt-labels class="stepper">
        <v-stepper-header>
          <v-stepper-step
            :complete="activeStep > 1"
            step="1"
            @click="goToStep('detalles')"
          >
            {{ $t("shared.flight_details")}}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            v-if="showHotelbedsStep"
            :complete="activeStep > 2"
            step="2"
            @click="goToStep('alojamiento')"
          >
            Alojamientos
          </v-stepper-step>
          <v-divider v-if="showHotelbedsStep"></v-divider>

          <v-stepper-step
            :complete="activeStep > (showHotelbedsStep ? 3 : 2)"
            :step="showHotelbedsStep ? 3 : 2"
            @click="goToStep('extras')"
          >
            {{ isPackFlight ? $t("shared.insurance") : $t("shared.extras") }}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            :complete="activeStep > (showHotelbedsStep ? 4 : 3)"
            :step="showHotelbedsStep ? 4 : 3"
            @click="goToStep('datos-personales')"
          >
            {{ $t("shared.data")}}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            :complete="activeStep > (showHotelbedsStep ? 4 : 3)"
            :step="showHotelbedsStep ? 5 : 4"
          >
            {{ $t("shared.payment")}}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <nights-step-details></nights-step-details>
          </v-stepper-content>

          <v-stepper-content step="2" v-if="showHotelbedsStep">
            <nights-step-accommodation :destination="this.destination" ></nights-step-accommodation>
          </v-stepper-content>

          <v-stepper-content :step="showHotelbedsStep ? '3' : '2'">
            <nights-step-extras></nights-step-extras>
          </v-stepper-content>

          <v-stepper-content :step="showHotelbedsStep ? '4' : '3'">
            <nights-step-data ref="nightsdata"></nights-step-data>
          </v-stepper-content>

          <v-stepper-content :step="showHotelbedsStep ? '5' : '4'">
            <nights-step-payment></nights-step-payment>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import NightsStepDetails from './details/NightsStepDetails.vue';
import NightsStepAccommodation from './accommodation/NightsStepAccommodation.vue';
import NightsStepExtras from './extras/NightsStepExtras.vue';
import NightsStepData from './personal-data/NightsStepData.vue';
import NightsStepPayment from './payment/NightsStepPayment.vue';
import steps from './steps';
import { goToStep } from './mixins';
import { mapGetters } from "vuex";
import {  NIGHTS_GET_IS_PACK_FLIGHT } from "../../store/nights/getter-types";

export default {
  mixins: [goToStep],
  components: {
    NightsStepDetails,
    NightsStepAccommodation,
    NightsStepExtras,
    NightsStepData,
    NightsStepPayment
  },

  props: {
    initialActiveStep: {
      type: Number,
      required: true,
    },
    destination: {
      type: String,
      required: true,
    },

  },
 created() {
    this.$eventHub.$on('update-overlay', this.handleOverlayUpdate);
  },
  beforeDestroy() {
    this.$eventHub.$off('update-overlay');
  },
  data() {
    return {
      overlay: false,
      steps,
      activeStep: this.initialActiveStep,
      showHotelbedsStep: window.show_hotelbeds,
    }
  },

  watch: {
    $route(route) {
      this.activeStep = this.steps.indexOf(route.params.step) + 1;
    }
  },
  methods: {
    handleOverlayUpdate(value) {
      this.overlay = value;
    }
  },
  computed: {
    ...mapGetters({
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT
    }),
  }
}
</script>

<style scoped lang="scss">
.stepper-container .container {
  @media (min-width: 1024px) {
    max-width: 960px;
  }
  @media (min-width: 1280px) {
    max-width: 90vw !important;
  }
  @media (min-width: 1680px) {
    max-width: 1380px !important;
  }
}
.v-stepper__step {
  &:not(.v-stepper__step--complete, .v-stepper__step--active) {
    pointer-events: none;
  }
}
.stepper-container::v-deep {
  .stepper.v-stepper .v-stepper__header {
    .v-stepper__step {
      flex-basis: 145px !important;
    }
    .v-divider {
      margin: 42px -54px 0 !important;
    }
    .v-stepper__label {
      text-align: center;

      @media (min-width: 1024px) {
        margin-left: -1.25rem;
        margin-right: -1.25rem;
      }
    }
  }
}
</style>
